enum Modals {
  changeEmail = 'changeEmail',
}

export default {
  [Modals.changeEmail]: {
    component: 'LazyChangeEmailAddress',
    props: { transition: { name: 'slide-bottom' }, selfClick: false },
  },
};
